import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import {BrowserRouter} from "react-router-dom";
import "./index.css"
import { MyContextProvider } from "./Context/MyContext";

ReactDOM.render(<><BrowserRouter><MyContextProvider><App/></MyContextProvider></BrowserRouter></>,document.getElementById("root"))